import Layout from '@/layout/default'
import auth from './middleware/auth'

export default [
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        component: () => import('@views/dashboard/index'),
        name: 'dashboard',
        meta: {
          title: 'Dashboard',
          middleware: [auth]
        }
      }
    ]
  },
  {
    path: '/profile',
    component: Layout,
    redirect: '/profile/index',
    children: [
      {
        path: 'index',
        component: () => import('@views/user/profile'),
        name: 'profile.index',
        meta: {
          title: 'Profile',
          middleware: [auth]
        }
      }
    ]
  },
  {
    path: '/projects',
    component: Layout,
    name: 'projects',
    redirect: '/projects/index',
    children: [
      {
        path: 'index',
        component: () => import('@views/project'),
        name: 'projects.index',
        meta: {
          title: 'Projects',
          middleware: [auth]
        }
      },
      {
        path: ':id/detail',
        component: () => import('@views/project/show'),
        name: 'projects.show',
        meta: {
          title: 'Project detail',
          middleware: [auth]
        }
      },
      {
        path: 'create',
        component: () => import('@views/project/create'),
        name: 'projects.create',
        meta: {
          title: 'Create project',
          middleware: [auth]
        }
      },
      {
        path: ':id/edit',
        component: () => import('@views/project/edit'),
        name: 'projects.edit',
        meta: {
          title: 'Edit project',
          middleware: [auth]
        }
      }
    ]
  },
  {
    path: '/my-workings',
    component: Layout,
    name: 'my-workings',
    redirect: '/my-workings/index',
    children: [
      {
        path: 'index',
        component: () => import('@views/my-working'),
        name: 'my-workings.index',
        meta: {
          title: 'My workings',
          middleware: [auth]
        }
      },
      {
        path: ':id/detail',
        component: () => import('@views/my-working/detail'),
        name: 'my-workings.detail',
        meta: {
          title: 'My working detail',
          middleware: [auth]
        }
      },
      {
        path: ':id/ask-support',
        component: () => import('@views/my-working/ask-support'),
        name: 'my-workings.ask-support',
        meta: {
          title: 'Ask for support',
          middleware: [auth]
        }
      },
      {
        path: ':id/completing',
        component: () => import('@views/my-working/completing'),
        name: 'my-workings.completing',
        meta: {
          title: 'Task completing',
          middleware: [auth]
        }
      }
    ]
  },
  {
    path: '/project-processes',
    component: Layout,
    name: 'project-processes',
    redirect: '/project-processes/index',
    children: [
      {
        path: 'index',
        component: () => import('@views/project-process'),
        name: 'project-processes.index',
        meta: {
          title: 'Project process',
          middleware: [auth]
        }
      },
      {
        path: ':id/detail',
        component: () => import('@views/project-process/show'),
        name: 'project-processes.show',
        meta: {
          title: 'Project process detail',
          middleware: [auth]
        }
      }
    ]
  },
  {
    path: '/task-evaluations',
    component: Layout,
    redirect: '/task-evaluations/index',
    children: [
      {
        path: 'index',
        component: () => import('@views/task-evaluation'),
        name: 'task-evaluations.index',
        meta: {
          title: 'Task evaluation',
          middleware: [auth]
        }
      }
    ]
  },
  {
    path: '/my-points',
    component: Layout,
    redirect: '/my-points/index',
    children: [
      {
        path: 'index',
        component: () => import('@views/my-point'),
        name: 'my-points.index',
        meta: {
          title: 'My points',
          middleware: [auth]
        }
      }
    ]
  },
  {
    path: '/tickets',
    component: Layout,
    name: 'tickets',
    redirect: '/tickets/index',
    children: [
      {
        path: 'index',
        component: () => import('@views/ticket'),
        name: 'tickets.index',
        meta: {
          title: 'Tickets',
          middleware: [auth]
        }
      },
      {
        path: ':id/detail',
        component: () => import('@views/ticket/detail'),
        name: 'tickets.detail',
        meta: {
          title: 'Ticket detail',
          middleware: [auth]
        }
      }
    ]
  },
  {
    path: '/feedback',
    component: Layout,
    name: 'feedback',
    redirect: '/feedback/index',
    children: [
      {
        path: 'index',
        component: () => import('@views/feedback'),
        name: 'feedback.index',
        meta: {
          title: 'Feedback',
          middleware: [auth]
        }
      },
      {
        path: 'create',
        component: () => import('@views/feedback/create'),
        name: 'feedback.create',
        meta: {
          title: 'Create feedback',
          middleware: [auth]
        }
      },
      {
        path: ':id/detail',
        component: () => import('@views/feedback/show'),
        name: 'feedback.show',
        meta: {
          title: 'Feedback detail',
          middleware: [auth]
        }
      }
    ]
  },
  {
    path: '/notifications',
    component: Layout,
    redirect: '/notifications/index',
    children: [
      {
        path: 'index',
        component: () => import('@views/notification'),
        name: 'notifications.index',
        meta: {
          title: 'Notifications',
          middleware: [auth]
        }
      }
    ]
  }
]
